import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Page from 'components/system/Page';
import { CompetitionPageStyles } from 'components/pages/Competition/competitionPage.styles';
import CompetitionHeaderStyles from 'components/pages/Competition/CompetitionHeader/competitionHeader.styles';
import JoinButton from 'components/pages/Competition/JoinButton';
import Loading from 'components/system/Loading';
import colors from 'styles/colors';
import Logo from 'assets/svgIcons/logo.svg';
import Icon from 'components/system/Icon';
import { dateOnlyFormatter } from 'utils/formatDateTime';
import { auth, useAuthState } from 'api/services/firebase';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useIsJoined from 'hooks/useIsJoined';

const CompetitionPageMobileView = ({
  isMobile, isAppLoaded, name, start, competition, competitionId,
}) => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const { isJoined, isChecking } = useIsJoined(competitionId);

  const [searchParams] = useSearchParams();

  const joinParamExists = searchParams.has('join');

  const [hasJoinedLoading, setHasJoinedLoading] = useState(true);

  useEffect(() => {
    if (isAppLoaded) {
      if (isMobile && !user && !joinParamExists && !isJoined && !isChecking) {
        window.location.href = 'https://www.bluequbit.io/quantum-computing-hackathon';
      }
      if (isMobile && user && !user.emailVerified) {
        navigate('/');
      }
    }
  }, [isAppLoaded, isChecking, isJoined, isMobile, joinParamExists, navigate, user]);

  return (
    <Container sx={{
      height: '100%',
      backgroundColor: colors.background.main,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
    >
      <Box
        sx={{
          height: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          flexDirection: 'column',
          scale: '1.5',
          marginTop: '16px',
        }}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item alignItems="center">
            <Box>
              <Logo />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {!hasJoinedLoading ? (
        <Box
          sx={{
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            flexDirection: 'column',
            marginTop: '20%',
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item alignItems="center">
              <Box sx={{
                '& svg': {
                  viewBox: '-125 0 1024 1024 !important',
                },
              }}
              >
                <Icon
                  name="competitions"
                  size={96}
                  color={colors.text.primary}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : null}
      {!hasJoinedLoading ? (
        <Page sx={CompetitionPageStyles}>
          <Typography
            variant="h5"
            component="h1"
            color={colors.text.primary}
            sx={{ textAlign: 'center' }}
          >
            Congratulations! You have successfully signed up for
            {' '}
            <Typography
              variant="h5"
              component="span"
              color={colors.primary.main}
            >
              {name || ''}
            </Typography>
            {' '}
            that starts on
            {' '}
            {dateOnlyFormatter(start) ?? ''}
            !
          </Typography>
          <Typography
            variant="h6"
            component="h1"
            color={colors.text.primary}
            sx={{ textAlign: 'center', marginTop: '10%' }}
          >
            Go to
            {' '}
            <Typography
              variant="h6"
              href="https://app.bluequbit.io/hackathons"
              component="a"
              sx={{
                color: colors.text.primary,
                lineHeight: '100%',
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                textDecorationSkipInk: 'none',
                textDecorationThickness: 'auto',
                textUnderlineOffset: 'auto',
                textUnderlinePosition: 'from-font',
              }}
            >
              https://app.bluequbit.io/hackathons
            </Typography>
            {' '}
            on your desktop to participate in the
            hackathon.
          </Typography>
        </Page>
      ) : <Loading />}
      <Box sx={{ visibility: 'hidden' }}>
        <JoinButton
          styles={CompetitionHeaderStyles.actionButton}
          id={competitionId}
          competition={competition}
          setHasJoinedLoading={setHasJoinedLoading}
        />
      </Box>
    </Container>
  );
};

export default CompetitionPageMobileView;
